import { render, staticRenderFns } from "./tabHeadNavigation.vue?vue&type=template&id=f42fc688&scoped=true"
import script from "./tabHeadNavigation.vue?vue&type=script&lang=js"
export * from "./tabHeadNavigation.vue?vue&type=script&lang=js"
import style0 from "./tabHeadNavigation.vue?vue&type=style&index=0&id=f42fc688&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f42fc688",
  null
  
)

export default component.exports